module.exports = __webpack_public_path__ + "assets/images/clt_y.6c3d30fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/clt_y.png
// module id = 692
// module chunks = 1